module.exports = __webpack_public_path__ + "static/Netwealth-7cd986b9b7b3901ac4f950ba7170bf59.png";